import { Environment } from './type';

export const environment: Environment = {
  awsRegion: 'eu-central-1',
  awsUserPoolId: 'eu-central-1_rCGJEgFg2',
  awsUserPoolWebClientId: '49hkrjh5lqjqm9ccq5p2pdrrf4',
  adminUrl: 'https://admin.volubus.com',
  apiUrl: '/api/v1',
};
